<template>
  <div>
    <user-profile-programs-table :user-id="userId" />
    <user-profile-pathways-table :user-id="userId" class="pt-5" />
    <user-profile-emphases-table :user-id="userId" class="pt-5" />
  </div>
</template>

<script>

  export default {
    parent: true,

    props: {
      userId: {
        type: String,
        default: () => '',
      },
    },
  };
</script>